import React from "react";
import LogoWhite from "./LogoWhite";
import Nav from "./Nav";
import MobileMenu from "./MobileMenu";
import LogoBox from "./LogoBox";
import OffCanvasStyleOne from "./OffCanvasStyleOne";
import SearchButton from "./SearchButton";
import { Link } from "react-router-dom";

export default class Header extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <>
        <header className="main-header main-header-three clearfix">
          <div className="mobile-header-contact">
            <p>
              <i className="fas fa-phone" /> +387 (62) 386-911
            </p>
          </div>
          <div className="mobile-header">
            <div className="logo-box">
              <Link to={process.env.PUBLIC_URL + `/`}>
                <img
                  src={
                    publicUrl + "assets/images/logo/logo-black-white-full.png"
                  }
                  alt="Logo"
                />
              </Link>
            </div>
            <MobileMenu />
          </div>

          <div className="main-header-three__wrapper">
            <div className="main-header-three__top clearfix">
              <div className="container">
                <div className="main-header-three__top-inner">
                  <div className="left"></div>

                  <div className="right">
                    <div className="title">
                      <p>Posjeti nas na društvenim mrežama!</p>
                    </div>

                    <ul className="social-links">
                      <li>
                        <a href="https://www.facebook.com/kalkangradnja/?locale=hr_HR">
                          <span className="icon-facebook-app-symbol"></span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/kalkangradnja/">
                          <span>
                            <img
                              style={{ maxWidth: "16px", maxHeight: "16px" }}
                              src="./assets/images/instagram.svg"
                              alt="Instagram"
                            />
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-header-three__middle">
              <div className="container">
                <div className="main-header-three__middle-inner">
                  <LogoBox />

                  <div className="contact-info">
                    <ul>
                      <li>
                        <div className="icon-box">
                          <span className="icon-email"></span>
                        </div>
                        <div className="text-box">
                          <h3>Podrška</h3>
                          <p className="email">
                            <a href="mailto:needhelp@company.com">
                              kalkanod@outlook.com
                            </a>
                          </p>
                        </div>
                      </li>

                      <li>
                        <div className="icon-box">
                          <span className="icon-phone-call"></span>
                        </div>
                        <div className="text-box">
                          <h3>Kontakt</h3>
                          <p className="number">
                            <a href="tel:38762386911">+387 (62) 386-911</a>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-header-three__bottom">
              <div className="container">
                <div className="main-header-three__bottom-inner">
                  <div className="main-header-one__bottom-left">
                    <nav className="main-menu main-menu--1">
                      <div className="main-menu__inner">
                        <div className="stricky-one-logo">
                          <LogoWhite />
                        </div>
                        <Nav />
                      </div>
                    </nav>
                  </div>

                  <div className="main-header-one__bottom-right">
                    <div className="search-box">
                      <SearchButton />
                    </div>

                    <div className="side-content-button-box">
                      <OffCanvasStyleOne />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="stricky-header stricked-menu main-menu">
          <div className="sticky-header__content"></div>
        </div>
      </>
    );
  }
}
